import { useTranslation } from 'react-i18next';
import { Lightbulb } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';
import { KeyboardShortcut } from '../components/KeyboardShortcut';

export function TipsSection() {
  const { t } = useTranslation('help');
  const s = 'sections.tips';

  return (
    <GuideSection
      id="tips"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={Lightbulb}
    >
      <GuideSubSection title={t(`${s}.globalSearch.title`)}>
        {/* "Ctrl+K" is rendered as key caps. Every translation keeps the literal, so the split
            always finds it; if one ever didn't, the sentence would simply render as plain text. */}
        <p>
          {t(`${s}.globalSearch.p1`).split('Ctrl+K')[0]}
          <KeyboardShortcut keys={['Ctrl', 'K']} />
          {t(`${s}.globalSearch.p1`).split('Ctrl+K').slice(1).join('Ctrl+K')}
        </p>
        <p>{t(`${s}.globalSearch.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.whatsNew.title`)}>
        <p>{t(`${s}.whatsNew.p1`)}</p>
        <p>{t(`${s}.whatsNew.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.savedFiltersTip.title`)}>
        <p>{t(`${s}.savedFiltersTip.p1`)}</p>
        <p>{t(`${s}.savedFiltersTip.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.keyboardNav.title`)}>
        <p>{t(`${s}.keyboardNav.p1`)}</p>
        <p>{t(`${s}.keyboardNav.p2`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
